import axios from "axios";

export const getApiKeyService = async ({ id }: {id: string}) => {
    try {
      const { data } = await axios.get<any>(`${process.env.NEXT_PUBLIC_BASE_URL}/api/school/api-key/${id}`);
      return data;
    } catch (error: any) {
      throw new Error(error);
    }
  };